import Mock from './Mock';

export default class LocalizationServiceMock {
  static getCountriesWithProvince() {
    return Mock.call();
  }
}
